import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';
import RecurringErrorMessage from 'components/RecurringErrorMessage/container';

export default styled(RecurringErrorMessage)`
  background: #fc9403;
  padding: ${gridSizes('M')};
  border-radius: 4px;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: start;
  text-align: left;

  min-height: 48px;

  span {
    font-size: ${gridSizes('M')};
    font-weight: ${weights('medium')};
  }
  svg {
    width: ${gridSizes('L')};
    height: ${gridSizes('L')};
    display: inline-block;
    vertical-align: middle;
    fill: #fff;
    margin-right: ${gridSizes('L')};
    margin-left: 12px;
    margin-top: ${gridSizes('S')};
    margin-bottom: ${gridSizes('S')};
  }
  .link {
    color: #fff;
    text-decoration: underline;
    cursor: pointer;
  }

  ${media.lessThan('extraSmall')`
        position: absolute;
        width: 100vw;
        left: 0;
        bottom: 0;
        border-radius: 0;
        svg{
            width: 20px;
            height: 20px;
            margin-right: 20px;
            margin-left: ${gridSizes('S')};
        }
    `};
`;
